
import React from "react";
import { Category } from "@/types";
import CategoryForm from "./CategoryForm";
import CategoriesTable from "./CategoriesTable";

interface CategoryTabProps {
  activeTab: "categories" | "subcategories";
  categories: Category[];
  subcategories: Category[];
  editingId: string | null;
  onSubmit: (values: any) => void;
  onEdit: (item: Category) => void;
  onDelete: (id: string) => void;
  resetForm: () => void;
}

const CategoryTab: React.FC<CategoryTabProps> = ({
  activeTab,
  categories,
  subcategories,
  editingId,
  onSubmit,
  onEdit,
  onDelete,
  resetForm
}) => {
  return (
    <>
      <CategoryForm
        activeTab={activeTab}
        editingId={editingId}
        categories={categories}
        onSubmit={onSubmit}
        onCancel={resetForm}
      />
      
      <CategoriesTable
        categories={categories}
        subcategories={subcategories}
        activeTab={activeTab}
        onEdit={onEdit}
        onDelete={onDelete}
      />
    </>
  );
};

export default CategoryTab;
